import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { AvailityServiceReviewConfiguration } from "risa-data-model";
import { Footer } from "risa-oasis-ui_v2";
import { makePostCallWithFormConfig } from "../../api/postCall/makePostCallWithFormConfig";
import BadgeWithIconRounded from "../../components/badgeWithIconRounded/badgeWithIconRounded";
import { LoaderMessage } from "../../components/loaderMessage/loaderMessage";
import {
  fetchAvailityServiceReviewConfiguration,
  updateAvailityServiceReviewConfiguration,
} from "../../redux/slice/form-slice";
import { getOrderDetailsFor } from "../../redux/slice/single-order-slice";
import { fetchSubmissionDocsForOrder } from "../../redux/slice/submissionDocsSlice";
import { AppDispatch, RootState } from "../../redux/store/store";
import RedWarningIcon from "../../svg/redWarningIcon";
import { generateFullName } from "../../utils/generateOrderDataForTable";
import { capitalizeString } from "../../utils/stringModifications";
import { ProcedurePaFrom } from "./ProcedurePaForm";

const ProcedurePaFormLayout = () => {
  const { id } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { data: singleOrder, loading: singleOrderLoading } = useSelector(
    (state: RootState) => state.singleOrder,
  );

  const { loading: initialLoader } = useSelector(
    (state: RootState) => state.availityServiceReviewConfiguration,
  );

  const { data: submissionDocs, loading: fetchingSubmissionDocs } = useSelector(
    (state: RootState) => state.submissionDocs,
  );

  useEffect(() => {
    if (id) {
      dispatch(getOrderDetailsFor(id));
      dispatch(fetchAvailityServiceReviewConfiguration(id));
      dispatch(fetchSubmissionDocsForOrder(id));
    }
  }, [id, dispatch]);
  const [configData, setConfigData] = useState<
    AvailityServiceReviewConfiguration | undefined
  >();
  const [loading, setLoading] = useState<boolean>(false);

  const handleConfigDataChange = (
    newConfigData: AvailityServiceReviewConfiguration,
  ) => {
    setConfigData(newConfigData);
  };

  const navigate = useNavigate();
  const chckIfAlreadySubmitted = () => {
    const hasQuestionnaire =
      submissionDocs?.["questionnaire"] &&
      Object.keys(submissionDocs["questionnaire"]).length > 0;

    const hasSubmissionStatus =
      submissionDocs?.["submission_status"] &&
      Object.keys(submissionDocs["submission_status"]).length > 0;

    return hasQuestionnaire || hasSubmissionStatus;
  };

  const handleSubmit = async () => {
    if (configData) {
      dispatch(updateAvailityServiceReviewConfiguration(configData));
      !chckIfAlreadySubmitted() &&
        makePostCallWithFormConfig(id ?? "", setLoading, configData);
      navigate(`/worklists/submission-status/${id}`);
    }
  };

  return (
    <div className="pharma-pa-form__container flex h-full flex-col bg-[#F7F9FA] px-[0.9375rem] py-[0.625rem]">
      <div className="pharma-pa-form__header mb-4"></div>
      <div className="pharma-pa-form__body flex flex-1 flex-col overflow-hidden rounded bg-white p-4 pb-0">
        <div className="pharma-pa-form__body--header mb-4">
          <div className="pharma-pa-form__body--header-details flex items-center gap-2">
            <div className="pharma-pa-form__body patient-name text-h16 font-semibold leading-6 text-primaryGray-1">
              {capitalizeString(
                generateFullName(
                  singleOrder?.Patient?.Demographics?.FirstName || "",
                  singleOrder?.Patient?.Demographics?.MiddleName || null,
                  singleOrder?.Patient?.Demographics?.LastName || null,
                ),
              )}
            </div>
            <BadgeWithIconRounded
              text="Continuation of care"
              icon={
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    background: "#008367",
                    borderRadius: "9999px",
                  }}
                ></div>
              }
              id="id2"
              bgColor="#E6F3F0"
              textColor="#1F1F1F"
              borderColor="#8AC6B9"
            />
            <BadgeWithIconRounded
              icon={<RedWarningIcon />}
              text="Non-preferred drugs"
              id="id3"
              bgColor="#FAE6E6"
              textColor="#1F1F1F"
              borderColor="#E88B8B"
            />
          </div>
        </div>
        <div className="pharma-pa-form__body content flex flex-1 overflow-hidden">
          {initialLoader || fetchingSubmissionDocs || singleOrderLoading ? (
            <>
              <LoaderMessage message="Fetching form configuration..." />
            </>
          ) : (
            <>
              <ProcedurePaFrom onConfigDataChange={handleConfigDataChange} />
            </>
          )}
        </div>
      </div>
      <div className="pharma-pa-form__footer">
        <Footer
          cancelButtonText={"Go Back"}
          submitButtonText={loading ? "Submitting..." : "Review and Submit"}
          onCancelClick={() => navigate(`/worklists/evbv/${id}`)}
          onSubmitClick={function (): void {
            handleSubmit();
          }}
          isDisabled={singleOrderLoading || loading}
        />
      </div>
    </div>
  );
};

export default ProcedurePaFormLayout;
